import { api } from "@/services/api";
import type { IStrategy, ILinkStrategyRequest, IAccount } from "@pulse-ui/codegen/generated_ts/org_entity";

export const accountStrategyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get linked strategy for an account
    getAccountStrategy: builder.query<IStrategy, string>({
      query: (accountId) => `/api/account/v1/venue_accounts/${accountId}/strategies`,
      providesTags: (_, __, accountId) => [{ type: "AccountStrategy", id: accountId }],
    }),

    // Link strategy to account
    linkAccountStrategy: builder.mutation<IAccount, { accountId: string; data: ILinkStrategyRequest }>({
      query: ({ accountId, data }) => ({
        url: `/api/account/v1/venue_accounts/${accountId}/strategies`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (_, __, { accountId }) => [
        { type: "AccountStrategy", id: accountId },
        { type: "Account", id: accountId },
        "OrgMetadata",
      ],
    }),

    // Unlink strategy from account
    unlinkAccountStrategy: builder.mutation<IAccount, { accountId: string; strategyId: string }>({
      query: ({ accountId, strategyId }) => ({
        url: `/api/account/v1/venue_accounts/${accountId}/strategies/${strategyId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, __, { accountId }) => [
        { type: "AccountStrategy", id: accountId },
        { type: "Account", id: accountId },
        "OrgMetadata",
      ],
    }),
  }),
});

export const {
  useGetAccountStrategyQuery,
  useLinkAccountStrategyMutation,
  useUnlinkAccountStrategyMutation,
} = accountStrategyApi;
